import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import Corporations from "./Corporations.jsx";
import Campuses from "./Campuses.jsx";
import AllServers from "./AllServers.jsx";
import {iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import PalPendantMap from "./PalPendantMap.jsx";

const Customers = (props) => {
    let pageContent, dData, paramVars, bData;
    paramVars = useParams();

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    if (paramVars?.dType === "corporations") {
        pageContent = <Corporations/>
    }else if (paramVars?.dType === "campuses"){
        pageContent = <Campuses />
    }else if (paramVars?.dType === "servers"){
        pageContent = <AllServers />
    }else{
        pageContent = (
            <div>
                404 Page not found
            </div>
        );
    }

    return (iAmHigherAuthority(80, dData?.my_role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Customers;